module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-fr-FR.1008aa4b.png";